// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"8c73b28f","221":"51b6517e","240":"77371b79","371":"7423286d","576":"e24a3b30","615":"c80b348e","722":"f9c69a01","855":"3e501dfd","918":"b6415583"}[chunkId] + ".chunk.css";
};